// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "owl-carousel" + "." + "9404b2f4" + ".chunk.css";
};